import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const Marquee = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/marquee")
      .then(({ data }) => setItems(data.map((d) => d.text)))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <div data-testid="marquee" className="relative border-y border-[#282836] bg-[#0C0C12] py-5 overflow-hidden">
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center">
            {items.map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl font-semibold tracking-wide text-[#9E9EB3] px-8">
                  {item}
                </span>
                <span className="text-[#FF5500] text-xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
